import {
    makeStyles 
} from '@mui/styles';
import {
    Box, Button, useTheme 
} from '@mui/material';
import {
    ChangeEvent, KeyboardEvent, useContext, useMemo 
} from 'react';
import {
    FormContext 
} from '../../../contexts/form';

type Props = {
    sectionKey: string,
    inputRef: any,
    value: string,
    onChange: (e: ChangeEvent) => void;
    onKeyPress: (e: KeyboardEvent) => void,
    unit?: string,
    showButton?: boolean,
    onClick?: () => void,
    error?: string,
    maxWidth?: number
};

const useStyles = makeStyles((theme) => ({
    inputBox: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: '0 auto'
    },
    unit: {
        fontWeight: 700,
        fontSize: '32px',
        lineHeight: '40px',
        fontFamily: 'Poppins',
        margin: '0 auto',
        width: '48px',
        textAlign: 'right',
        transform: 'translate(-12px, 0)'
    },
    input: {
        width: '126px',
        padding: '8px 13px',
        borderRadius: '6px',
        outline: 'none',
        fontWeight: 600,
        fontSize: '36px',
        lineHeight: '48px',
        fontFamily: 'Poppins',
        textAlign: 'center',
        backgroundColor: theme.palette.secondary.light
    },
    rightArrow: {
        position: 'absolute',
        transform: 'translate(113px, 0)'
    },
    arrowButton: {
        padding: '16px',
        borderRadius: '50%',
        minWidth: 0,
        lineHeight: 0,
        transform: 'translate(12px, 0)'
    },
}));

export const NumberInputScreen = ({
    sectionKey,
    inputRef,
    onChange,
    onKeyPress,
    value,
    unit,
    showButton,
    onClick,
    error,
    maxWidth
}: Props): JSX.Element => {
    const formContext = useContext(FormContext);
    const classes = useStyles();
    const theme = useTheme();
    const section = useMemo(() => {
        return formContext?.sections.find(s => s.key === sectionKey);
    }, [sectionKey, formContext?.sections]);

    return (
        <Box className={classes.inputBox}>
            {unit && (
                <p className={classes.unit}>
                    {unit}
                </p>
            )}
            <input
                ref={inputRef}
                type="number"
                inputMode="numeric"
                step="1"
                className={classes.input}
                onKeyPress={onKeyPress}
                onChange={onChange}
                style={{
                    border: `2px solid ${section?.colors.main}`,
                    maxWidth,
                    color: theme.palette.neutral.main
                }}
                value={value}
            />
            {showButton && (
                <Button
                    className={classes.arrowButton}
                    style={{
                        backgroundColor: (!value || error) ? theme.palette.neutral['100'] : theme.palette.secondary.main,
                        cursor: (!value || error) ? 'not-allowed' : 'pointer'
                    }}
                    onClick={onClick}
                >
                    <svg
                        width="16"
                        height="16"
                        viewBox="0 0 17 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M8.70503 14.095C8.43166 13.8216 8.43166 13.3784 8.70503 13.105L13.1101 8.69999L2.2 8.69999C1.8134 8.69999 1.5 8.38659 1.5 7.99999C1.5 7.61339 1.8134 7.29999 2.2 7.29999L13.1101 7.29999L8.70503 2.89496C8.43166 2.62159 8.43166 2.17838 8.70503 1.90501C8.97839 1.63164 9.42161 1.63164 9.69498 1.90501L15.295 7.50501C15.5683 7.77838 15.5683 8.22159 15.295 8.49496L9.69497 14.095C9.42161 14.3683 8.97839 14.3683 8.70503 14.095Z"
                            fill={theme.palette.white}
                        />
                    </svg>
                </Button>
            )}
        </Box>
    );
};

export default NumberInputScreen;
